// Client de la venta de mostrador de accesorios en `retail-wizard-business`: el cierre de la venta,
// sin cliente, con su llave de idempotencia.
import type { Sale } from '@fiado/type-kit/bin/retailWizard/dtos/Sale';
import { apiFetch } from '../../client';
import type { components } from './retail-wizard.gen';

/** Body de `publicCreateAccessorySale`; el método viaja como `WIRE`, no `SPEI`. */
export type CreateAccessorySaleRequest = components['schemas']['CreateAccessorySaleRequest'];
export type AccessorySaleLine = components['schemas']['AccessorySaleLine'];
/** Lo que el ticket lee de la venta cerrada. */
export type AccessorySale = Pick<Sale, 'saleId' | 'folio' | 'amountCents' | 'soldAt'>;

const BASE_URL = import.meta.env.VITE_API_RETAIL_WIZARD_BASE_URL;
const ROOT = '/wizard/accessory-sales';

export const accessorySalesApi = {
    /** `publicCreateAccessorySale`: el reintento con la misma llave devuelve la misma venta. */
    createSale: (request: CreateAccessorySaleRequest, idempotencyKey: string) =>
        apiFetch<Sale>(ROOT, {
            baseUrl: BASE_URL,
            method: 'POST',
            body: JSON.stringify(request),
            headers: { 'Idempotency-Key': idempotencyKey },
        }),
};
